
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","viewBox":"0 0 54 54"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Pfad 3","d":"M38.824 39.357L37.366 17.12a.93.93 0 00-.928-.87h-4.071v-.6A4.657 4.657 0 0027.715 11h-1.6a4.657 4.657 0 00-4.652 4.652v.6h-4.071a.93.93 0 00-.928.87l-1.462 22.289a.93.93 0 00.928.991H37.9a.93.93 0 00.93-.93.956.956 0 00-.006-.115zm-15.5-23.7a2.794 2.794 0 012.791-2.791h1.6a2.794 2.794 0 012.791 2.791v.6h-7.182zm-6.4 22.889l1.34-20.43h3.2v.83a2.047 2.047 0 101.861 0v-.83h7.182v.83a2.047 2.047 0 101.861 0v-.83h3.2l1.34 20.43z","fill":"currentColor"}})])
          )
        }
      }
    